import React from 'react'

export default function CartasTecnicas() {
    return (
        <div>
            Cartas Técnicas
        </div>
    )
}
